<template>
  <p v-if="data" class="se-icon">
    <public-icon name="icon-bd" type="1" v-if="data.toString().indexOf('1') > -1" />
    <public-icon name="icon-gg" type="1" v-if="data.toString().indexOf('2') > -1" />
    <public-icon name="icon-360" type="1" v-if="data.toString().indexOf('3') > -1" />
    <public-icon name="icon-sg" type="1" v-if="data.toString().indexOf('4') > -1" />
    <public-icon name="icon-sjbd" type="1" v-if="data.toString().indexOf('5') > -1" />
    <public-icon name="icon-sm" type="1" v-if="data.toString().indexOf('6') > -1" />
    <public-icon name="icon-sjsg" type="1" v-if="data.toString().indexOf('7') > -1" />
  </p>
</template>
<script>
export default {
  name: 'SeIcon',
  props: ['data'],
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
.se-icon {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/SeIcon.vue